import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { Http, Response, RequestOptions } from '@angular/http';

import { HttpClient, HttpRequest, HttpEvent, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { SessionHelper } from './session.helper';
import { Router } from '@angular/router';
import { DataSharingService } from '../services/data-sharing.service';
import { environment } from '../../../environments/environment';

@Injectable()
/**
 * This class provides the helper method to execute Web API request.
 */
export class HttpHelper {



    constructor(private httpClient: HttpClient, private authService: AuthService, private router: Router, private dataSharingService: DataSharingService) {
    }



    /**
     *  Executes the get request with given uri parameters and header values.
     * @param url: The reqeust URI.
     * @param args: The reqeust argument.
     */
    get(url: string, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {
        if (!this.authService.isTokenExpired()) {
            if (url.includes('scraping/accounthistory/negativeaccountnames')) {
                this.dataSharingService.setShowLoader(true);
            }
            const headers = this.getHttpHeaders();
            return this.httpClient.get(url, { headers })
                .map((res: Response) => {
                    if (url.includes('scraping/accounthistory/negativeaccountnames')) {
                        this.dataSharingService.setShowLoader(false);
                    }
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }

    /**
     * Executes the post request with given uri parameters and header values.
     * @param url: The reqeust URI.
     * @param data: The reqeust object.
     * @param args: The request argument.
     */
    post(url: string, data: any, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {

        if (!this.authService.isTokenExpired()) {
            const headers = this.getHttpHeaders();

            return this.httpClient.post(url, JSON.stringify(data), { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }


    /**
     * Executes the post request with given uri parameters and header values.
     * @param url: The reqeust URI.
     * @param data: The reqeust object.
     * @param args: The request argument.
     */
    postFile(url: string, data: any, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {
        if (!this.authService.isTokenExpired()) {
            let headers = new HttpHeaders().set('Content-Type', 'application/json')
                .set('Accept', 'application/json');
            if (requestOptions.headers.keys().toString() == 'RequestModel') {
                headers = new HttpHeaders().set('RequestModel', requestOptions.headers.values()[0].toString());
            }
            if (this.authService.hasToken()) {
                headers = headers.set('Authorization', `Bearer ${this.authService.getToken()}`);
            }
            return this.httpClient.post(url, data, { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }


    /**
    * Executes the post request with given uri parameters and header values.
    * @param url: The reqeust URI.
    * @param data: The reqeust object.
    * @param args: The request argument.
    */
    putFile(url: string, data: any, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {
        if (!this.authService.isTokenExpired()) {

            let headers = new HttpHeaders().set('Content-Type', 'application/json')
                .set('Accept', 'application/json');
            if (requestOptions.headers.keys().toString() == 'RequestModel') {
                headers = new HttpHeaders().set('RequestModel', requestOptions.headers.values()[0].toString());
            }
            if (this.authService.hasToken()) {
                headers = headers.set('Authorization', `Bearer ${this.authService.getToken()}`);
            }

            if (requestOptions.headers.keys().toString() == 'RequestModel') {
                headers = headers.set('RequestModel', requestOptions.headers.values()[0].toString());
            }

            return this.httpClient.put(url, data, { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }

    downloadFile(url: string, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<HttpEvent<any>> {
        if (!this.authService.isTokenExpired()) {
            // let headers = new HttpHeaders();
            // requestOptions.headers.keys().forEach((value, key) => {
            //     headers = headers.set(value, requestOptions.headers.values()[key].toString());
            // });
            // if (this.authService.hasToken()) {
            //     headers = headers.set('Authorization',`Bearer ${this.authService.getToken()}`);
            // }
            const req = new HttpRequest('GET', `${url}`, {
                reportProgress: true,
                responseType: 'blob'
            });
            return this.httpClient.request(req);
        } else {
            this.clearCurrentSession();
        }
    }

    /**
     * Executes the put request with given uri parameters and header values.
     * @param url: The reqeust URI.
     * @param data: The reqesut object.
     * @param args: The reqesut argument.
     */
    put(url: string, data: any, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {
        if (!this.authService.isTokenExpired()) {
            const headers = this.getHttpHeaders();
            return this.httpClient.put(url, JSON.stringify(data), { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }

    /**
    * Executes the put request with given uri parameters and header values.
    * @param url: The reqeust URI.
    * @param data: The reqesut object.
    * @param args: The reqesut argument.
    */
    patch(url: string, data: any, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {
        if (!this.authService.isTokenExpired()) {
            const headers = this.getHttpHeaders();

            return this.httpClient.patch(url, JSON.stringify(data), { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }


    /**
    * Executes the put request with given uri parameters and header values.
     * @param url: The reqeust URI.
     * @param data: The reqesut object.
     * @param args: The reqesut argument.
     */
    remove(url: string, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<any> {

        if (!this.authService.isTokenExpired()) {
            const headers = this.getHttpHeaders();

            return this.httpClient.delete(url, { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }

    private clearCurrentSession() {
        SessionHelper.clearCustomerSession();
        this.router.navigateByUrl('/auth/login');
    }

    private getHttpHeaders(): HttpHeaders {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json');
        if (this.authService.hasToken()) {
            headers = headers.set('Authorization', `Bearer ${this.authService.getToken()}`);
        }
        return headers;
    }


    upload(url: string, data: any, requestOptions: RequestOptions): Observable<any> {
        if (!this.authService.isTokenExpired()) {
            let headers = new HttpHeaders();
            requestOptions.headers.keys().forEach((value, key) => {
                headers = headers.set(value, requestOptions.headers.values()[key].toString());
            });
            if (this.authService.hasToken()) {
                headers = headers.set('Authorization', `Bearer ${this.authService.getToken()}`);
            }
            return this.httpClient.post(url, data, { headers })
                .map((res: Response) => {
                    return res;
                });
        } else {
            this.clearCurrentSession();
        }
    }

    getWithProgress(url: string, requestOptions: RequestOptions, enableAPILog?: boolean, actionName?: string): Observable<HttpEvent<any>> {
        if (!this.authService.isTokenExpired()) {
            let headers = new HttpHeaders();
            requestOptions.headers.keys().forEach((value, key) => {
                headers = headers.set(value, requestOptions.headers.values()[key].toString());
            });
            if (this.authService.hasToken()) {
                headers = headers.set('Authorization', `Bearer ${this.authService.getToken()}`);
            }
            const req = new HttpRequest('GET', `${url}`, {
                headers: headers,
                reportProgress: true,
                responseType: 'json'
            })
            return this.httpClient.request(req);
        } else {
            this.clearCurrentSession();
        }
    }





}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/helpers/http.helper.ts